export default "__VITE_ASSET__78e59519__"